




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class PGRowIntValue extends Vue {
  @Prop() private value!: number;
  @Prop() private isEditable!: boolean;
  private intValue = 0;

  constructor() {
    super();
    this.intValue = this.value;
  }

  saveChange(): void {
    this.$emit('valueChanged', parseInt(this.intValue.toString()));
  }

  @Watch('value')
  refresh() {
    this.intValue = this.value;
  }
}
